import { MetadataKey, TrialType, type User } from '@revelio/data-access';

export const isValidEmail = (email: string): boolean => {
  return !!/\S+@\S+\.\S+/.test(email || '') && !email.includes(' ');
};

export const isValidEmailOrUsername = (input: string): boolean => {
  if (!input.includes('@') && !input.includes(' ')) {
    return true;
  }
  return isValidEmail(input);
};

export const hasUppercaseLetter = (password: string): boolean => {
  return !!password.match(/[A-Z]/g);
};

export const hasNumberOrSpecialCharacter = (password: string): boolean => {
  return !!password.match(/[0-9]|(?=.*?[#?!@$%^&*-:()])/g);
};

export const isValidPassword = (password: string): boolean => {
  return !!(
    password.length > 7 &&
    hasNumberOrSpecialCharacter(password) &&
    hasUppercaseLetter(password)
  );
};

export const isUserTrialExpired = (user: User) => {
  if (user.live) return false;
  const expirationDate = user?.metadata?.find(
    (m) => m?.key === MetadataKey.ExpirationDate
  )?.value;
  if (!expirationDate) return false;
  return new Date(expirationDate) < new Date();
};

export const getUserTrialType = (user: User): TrialType | false => {
  if (user.live) return false;
  return (
    (user?.metadata?.find((m) => m?.key === MetadataKey.TrialType)
      ?.value as TrialType) || TrialType.ONE_YEAR_DATA_LAG
  );
};

export const hasUserCompletedTourAndToS = (user: User) => {
  const { tour, tos } = user?.metadata?.reduce(
    (result, m) => {
      if (m?.key === MetadataKey.TourCompleted) {
        result.tour = m.value == 'true';
      }

      if (m?.key === MetadataKey.TermsAccepted) {
        result.tos = m.value == 'true';
      }

      return result;
    },
    { tour: false, tos: false }
  ) || { tour: false, tos: false };

  return tour && tos;
};
